import DialogContent from '@zenbusiness/zui/DialogContent';
import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const ContentWrapper = styled(Stack)(({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '3 / 11'
  }
}));

export const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  marginTop: 40,
  [theme.breakpoints.up('md')]: {
    marginTop: 80
  }
}));

export const BoxContentStyled = styled(Stack)(({ theme }) => ({
  padding: '24px',
  [theme.breakpoints.up('md')]: {
    padding: '32px 32px 56px'
  },
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '12px'
}));

export const LinkStyled = styled(Link)(() => ({
  cursor: 'pointer',
  textDecoration: 'underline'
}));

export const WrapperFAQStyled = styled(Stack)(() => ({
  paddingBottom: '50px'
}));
